import { render, staticRenderFns } from "./DocumentPage4.vue?vue&type=template&id=6844e77c&scoped=true&"
import script from "./DocumentPage4.vue?vue&type=script&lang=js&"
export * from "./DocumentPage4.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPage4.vue?vue&type=style&index=0&id=6844e77c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6844e77c",
  null
  
)

export default component.exports